import { sdk } from '@wix/image-kit';
import { getFullImageDescriptor, } from './getFullImageDescriptor';
export var ImageScaleType;
(function (ImageScaleType) {
    ImageScaleType[ImageScaleType["FILL"] = 0] = "FILL";
    ImageScaleType[ImageScaleType["FIT"] = 1] = "FIT";
    ImageScaleType[ImageScaleType["CROP"] = 2] = "CROP";
})(ImageScaleType || (ImageScaleType = {}));
export function getScaledImageUrl(image, options, scaleType) {
    if (options === void 0) { options = {}; }
    if (scaleType === void 0) { scaleType = ImageScaleType.FILL; }
    var resultImage = getFullImageDescriptor(image);
    switch (scaleType) {
        case ImageScaleType.FIT:
            // https://github.com/wix-private/wow-libs/blob/a3980498c4c3774aedecebb94a0573095f9d2832/packages/image-kit/src/sdk/api.ts#L26
            return sdk.getScaleToFitImageURL(resultImage.relativeUrl, resultImage.sourceWidth, resultImage.sourceHeight, resultImage.targetWidth, resultImage.targetHeight, options);
        case ImageScaleType.CROP:
            // sdk.getCropImageURL
            throw new Error('Not implemented method getCropImageURL');
        case ImageScaleType.FILL:
        default:
            // https://github.com/wix-private/wow-libs/blob/a3980498c4c3774aedecebb94a0573095f9d2832/packages/image-kit/src/sdk/api.ts#L55
            return sdk.getScaleToFillImageURL(resultImage.relativeUrl, resultImage.sourceWidth, resultImage.sourceHeight, resultImage.targetWidth, resultImage.targetHeight, options);
    }
}
//# sourceMappingURL=getScaledImageUrl.js.map